import { createAction, handleActions } from "redux-actions";
import _includes from "lodash/includes";
//
import { createPromiseActionTypes } from "../../utils/redux";
import Api from "../../services/Api";
import { AJAX_ERROR, ajaxErrorAction } from "../ajax";
import { INTL_CITY_SET } from "../intl";
import { LOCATION_GET } from "../locations";

// Action Types
const PLACE_SEARCH = createPromiseActionTypes("places/PLACE_SEARCH");

//  Actions
const searchPlacePendingAction = createAction(PLACE_SEARCH.PENDING);
const setPlacesAction = createAction(PLACE_SEARCH.FULFILLED);

export const searchPlaceAction = (query) => async (dispatch, getState) => {
  const { intl, uuid } = getState();

  // TODO: check last query / CACHE / etc
  dispatch(searchPlacePendingAction());

  try {
    dispatch(setPlacesAction(await Api.searchPlace(query, intl.cityId, uuid)));
  } catch (err) {
    if (err.data) {
      dispatch(ajaxErrorAction(err.data));
    } else {
      throw err;
    }
  }
};

//  Reducer
const initialState = {
  entities: {},
  result: [],
};

export default handleActions(
  {
    [PLACE_SEARCH.FULFILLED]: applySearchPlace,
    [LOCATION_GET.FULFILLED]: applyReset,
    [PLACE_SEARCH.PENDING]: applyReset,
    [INTL_CITY_SET]: applyReset,
    [AJAX_ERROR]: applyAjaxError,
  },
  initialState
);

//  Action Reducers
function applySearchPlace(state, action) {
  const { entities, result } = action.payload;

  return {
    ...state,
    entities: { ...state.entities, ...entities.places },
    result,
  };
}

function applyAjaxError(state, action) {
  const { error } = action.payload;

  if (error !== "location_too_far") {
    return state;
  }

  return applyReset(state, action);
}

function applyReset(state) {
  return { ...state, result: [] };
}
